import { Button, styled } from '@mui/material';

export const SuccessButton = styled(Button)`
  flex: 1;
  height: 28px;
  border-radius: 8px;
  box-shadow: none;
  background-color: var(
    --background-badge-green-accent,
    #26bd6c
  ) !important;
  text-transform: none;
`;
